import { render, staticRenderFns } from "./FacturasTable.vue?vue&type=template&id=1f9da6e9"
import script from "./FacturasTable.vue?vue&type=script&lang=js"
export * from "./FacturasTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports